export const maskPhoneNum = (value) => {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    const maskedValue = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  
    return maskedValue;
  }


  export const maskSsn = (value) => {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,2})(\d{0,4})/);
    const maskedValue = x[1] + (x[2] ? '-' + x[2] : '') + (x[3] ? '-' + x[3] : '');
  
    return maskedValue;
  }


export const maskDigits = (value) => {
    return value.replace(/\D/g, '');
}


export const maskLetters = (value) => {
  return value.replace(/\d/g, '');
}

export const maskDate = (value) => {
  const x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})/);
  const maskedValue = x[1] + (x[2] ? '/' + x[2] : '')

  return maskedValue;
}
